export default __webpack_public_path__ + "static/media/alertIconYellow.f3d1c0ec.svg";